import { useCallback, useEffect, useState } from 'react'
import { NotesApi } from '../api/NotesApi'

const notesApi = new NotesApi()

export const useEntityNoteIds = () => {
    const [entityIdsWithNotes, setEntityIdsWithNotes] = useState<Set<string> | null>(null)

    const reloadEntityNoteIds = useCallback(async () => {
        try {
            const notes = await notesApi.listNotes()
            const ids = new Set(notes.filter((note) => note.content?.trim()).map((note) => note.entityId))
            setEntityIdsWithNotes(ids)
        } catch (err) {
            console.error(err)
            setEntityIdsWithNotes(new Set())
        }
    }, [])

    useEffect(() => {
        void reloadEntityNoteIds()
    }, [reloadEntityNoteIds])

    return { entityIdsWithNotes, reloadEntityNoteIds }
}
